import { colors } from '../../../shared/styles/baseStyle';

const baseRowStyle = {
  background: colors.bgGrey,
  borderRadius: 8,
  padding: '10px 14px'
};

const styles = {
  durationRow: {
    ...baseRowStyle,
    marginBottom: 10
  },
  limitRow: baseRowStyle,
  colIcon: {
    marginRight: 12
  },
  label: {
    fontSize: 10
  }
};

export default styles;
